export default "__VITE_ASSET__CNDB817R__"